export default __webpack_public_path__ + "static/media/216property-gallery3.dcc98fb4.webp";